<template>
	<div class="animated fadeIn">
		<SubscriptionHeaderV2 active="send" :record_id="channel_id">
			<div class="m-3">
				<tooltip label="Driver" placement="right">
					<select @change="getCountSubscribers" class="form-control" v-model="platform">
						<option :value="null">{{ $t('All') }}</option>
						<option value="web">{{ $t('web') }}</option>
						<option value="sub_facebook">{{ $t('Facebook') }}</option>
						<option value="whats">{{ $t('Whatsapp') }}</option>
					</select>
				</tooltip>

				<tooltip
					v-for="(v, iv) in vars"
					:label="v.sv_variable_name"
					placement="right"
					:key="'var_' + iv"
				>
					<multiselect
						v-model="var_vals[v.sv_variable_name]"
						:options="v.vals"
						placeholder="All"
						@input="getCountSubscribers"
					></multiselect>
				</tooltip>

				<tooltip label="subscripers count" placement="top">
					<input
						type="text"
						name="sub_count"
						:placeholder="$t('subscripers count')"
						:class="{'form-control': true, 'is-invalid': errors.has('sub_count')}"
						v-validate="'required|min_value:1'"
						v-model="sub_count"
						style="color: red;"
						readonly
					/>
					<span
						v-if="errors.has('sub_count')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first('sub_count')) }}</span>
				</tooltip>

				<b-nav tabs>
					<b-nav-item
						v-for="(type, i) in notification_types"
						:active="data.type == type.value"
						@click="data.type = type.value"
						:key="'b-nav-item-' + i"
					>{{ $t(type.label) }}</b-nav-item>
				</b-nav>

				<div class="mt-4">
					<div v-if="data.type == 'text'">
						<tooltip label="title" placement="right" disabled>
							<textarea
								style="resize: vertical;"
								rows="5"
								name="title"
								:placeholder="$t('title')"
								v-model="data.title"
								v-validate="'required'"
								:class="{
                                            'form-control': true,
                                            'is-invalid': errors.has('title'),
                                        }"
								v-autocomplete="autocomplete"
							></textarea>
							<span
								v-if="errors.has('title')"
								class="help is-danger invalid-feedback"
							>{{ $t(errors.first('title')) }}</span>
						</tooltip>
					</div>
					<div v-else-if="~!!['card', 'image', 'video'].indexOf(data.type)">
						<ComamandResponseCard
							:buttons="data.buttons"
							:title="data.title || data.title_default_value"
							:subTitle="data.subtitle || ''"
							:autoCompleteModules="autocomplete"
							:checkMediaBackground="true"
							:media="data.media || ''"
							@onNewButtonClick="pushButton(data.buttons)"
							@onRemoveButtonClick="(pos) => removeButton(pos, data.buttons)"
						>
							<template slot="title">
								<tooltip label="title" placement="right" disabled>
									<input
										name="title"
										v-autocomplete="autocomplete"
										v-model="data.title"
										:placeholder="$t('title')"
										v-validate="'required'"
										:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.has('title'),
                                                }"
									/>
									<span
										v-if="errors.has('title')"
										class="help is-danger invalid-feedback"
									>{{ $t(errors.first('title')) }}</span>
								</tooltip>
							</template>
							<template slot="subTitle">
								<tooltip label="subtitle" placement="right" disabled>
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="data.subtitle"
										:placeholder="$t('subtitle')"
									/>
								</tooltip>
							</template>
							<template slot="media">
								<tooltip label="media link" placement="right" disabled>
									<input
										name="media"
										v-model.trim="data.media"
										placeholder="https://"
										v-validate="'required|url'"
										:class="{
                                                    'form-control': true,
                                                    'is-invalid': errors.has('media'),
                                                }"
									/>
									<span
										v-if="errors.has('media')"
										class="help is-danger invalid-feedback"
									>{{ $t(errors.first('media')) }}</span>
								</tooltip>
							</template>
							<template :slot="'button.label.' + ii" v-for="(button, ii) in  data.buttons">
								<tooltip label="button label" placement="right" disabled :key="ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_label_key"
										:placeholder="$t('button label')"
									/>
								</tooltip>
							</template>
							<template :slot="'button.value.' + ii" v-for="(button, ii) in  data.buttons">
								<tooltip label="button value" placement="right" disabled :key="ii">
									<input
										class="form-control"
										v-autocomplete="autocomplete"
										v-model="button.item_value_key"
										:placeholder="$t('button value')"
									/>
								</tooltip>
							</template>
						</ComamandResponseCard>
					</div>
				</div>

				<tooltip label="redirect_type" placement="right">
					<select
						name="redirect_type"
						:class="{'form-control': true, 'is-invalid': errors.has('redirect_type')}"
						v-model="data.redirect_type"
						v-validate="'required'"
					>
						<option value="web_wedgit">{{$t('web_wedgit')}}</option>
						<option value="custom_link">{{$t('custom_link')}}</option>
					</select>
					<span
						v-if="errors.has('redirect_type')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first('redirect_type')) }}</span>
				</tooltip>

				<tooltip label="link" placement="right" disabled v-if="data.redirect_type == 'custom_link'">
					<input
						name="redirect_link"
						v-model.trim="data.redirect_link"
						placeholder="https://"
						v-validate="'required|url'"
						:class="{
                                    'form-control': true,
                                    'is-invalid': errors.has('redirect_link'),
                                }"
					/>
					<span
						v-if="errors.has('redirect_link')"
						class="help is-danger invalid-feedback"
					>{{ $t(errors.first('redirect_link')) }}</span>
				</tooltip>
				<tooltip label="API Template" placement="right">
					<div class="codemirror-area">
						<codemirror
							class="code_view"
							v-model="apiRequestTemplate"
							:options="Object.assign({}, cm_options, {lineNumbers: false})"
						/>
					</div>
				</tooltip>

				<b-progress :max="notifications_pending" v-if="stream_status">
					<b-progress-bar
						variant="success"
						:value="notifications_success"
						:label="` ${notifications_success.toFixed(0)} ${$t('sent')} / ${notifications_pending - notifications_success} ${$t('pending')}`"
						height="3px"
						animated
					></b-progress-bar>
				</b-progress>

				<b-button variant="primary" @click="send" class="mb-0">
					<font-awesome-icon icon="paper-plane" />
					{{$t('send')}}
				</b-button>
			</div>
		</SubscriptionHeaderV2>
	</div>
</template>
<script>
	import './send.css'
	import axios from 'axios'
	import 'vue-multiselect/dist/vue-multiselect.min.css'
	import SubscriptionHeaderV2 from '../../components/SubscriptionHeaderV2'
	import ComamandResponseCard from '../../components/ComamandResponseCard'
	import {codemirror} from 'vue-codemirror'
	import Multiselect from 'vue-multiselect'
	import {NativeEventSource, EventSourcePolyfill} from 'event-source-polyfill'

	export default {
		name: 'Subscription',
		components: {
			codemirror,
			SubscriptionHeaderV2,
			ComamandResponseCard,
			Multiselect,
		},
		data() {
			return {
				counter: 0,
				stream_status: true,
				stream_source: null,
				notifications_pending: 0,
				notifications_success: 0,
				autocomplete: window.clone(this.$store.state.autocomplete),
				notification_types: [
					{
						label: 'text',
						value: 'text',
					},
					{
						label: 'Card URL or List',
						value: 'card',
					},
					{
						label: 'video',
						value: 'video',
					},
					{
						label: 'image',
						value: 'image',
					},
				],
				data: {
					type: 'text',
					title: '',
					subtitle: '',
					media: '',
					buttons: [
						{
							item_label_key: '',
							item_value_key: '',
						},
					],
					redirect_type: 'web_wedgit',
					redirect_link: '',
				},
				channel_id: 0,
				command_id: 0,
				vars: [],
				var_vals: {},
				platform: null,
				chatbots: [],
				chatbot_id: null,
				sub_count: 0,
				per_circle: 0,
				item: {},
				cm_options: {
					mode: 'text/x-sh',
					...this.$store.state.cm_base_options,
					theme: 'base16-dark',
					readOnly: true,
					line: !true,
				},
			}
		},

		computed: {
			apiRequestTemplate: {
				set() {
					return this.getApiRequestTemplate()
				},
				get() {
					return this.getApiRequestTemplate()
				},
			},
		},

		methods: {
			prepareEndpoint() {
				return (
					'/subscription/browse/' +
					this.channel_id +
					(!isNaN(this.command_id) && this.command_id > 0 ? '/' + this.command_id : '')
				)
			},

			initComponent(channel_id = 0, command_id = 0) {
				this.channel_id = channel_id
				this.command_id = command_id

				if (channel_id >= 1) {
					this.$root.loader = true
					axios.get(this.prepareEndpoint()).then(({data}) => {
						this.$root.loader = false
						if (data.status) {
							this.item = data.data
							this.vars = data.vars
							this.notifications_pending = data.notifications_pending
							this.vars.forEach((variable) => {
								this.$set(this.var_vals, variable.sv_variable_name, null)
							})
							this.getCountSubscribers()
							this.streamOpen()
						}
					})
				} else {
					this.$router.push({
						path: '/subscription',
					})
				}
			},

			getApiRequestTemplate() {
				var key = this.getKey()
				var data = window.clone(this.getTemplateRequestData())

				if (window.is_obj(data) && key) {
					delete data.stream_status
					var post_data = JSON.stringify(data, null, 4)
					return (
						'curl -X POST -H "Content-Type: application/json" -d \'' +
						post_data +
						'\' "' +
						process.env.VUE_APP_API_URL +
						'/subscription/send_to_subscribers_from_api?access_key=' +
						key +
						'"'
					)
				}
				return ''
			},

			streamUrl() {
				return process.env.VUE_APP_API_URL + '/stream_fetch/subscription/' + this.channel_id
			},

			streamListener(event) {
				var type = event.type
				var data = event.data
				switch (type) {
					case 'message':
						if (data == 'notification_sent') {
							this.notifications_success++
						}

						break

					default:
						break
				}
				console.log(type, data)
			},

			streamCustomHeader() {
				const token = localStorage.getItem('token')
				return {
					headers: {
						Authorization: 'Bearer ' + token,
					},
				}
			},

			streamOpen() {
				var es = new EventSourcePolyfill(this.streamUrl(), this.streamCustomHeader())
				es.addEventListener('open', this.streamListener)
				es.addEventListener('message', this.streamListener)
				es.addEventListener('error', this.streamListener)
			},

			getValidatorFields() {
				return ['chatbot', 'sub_count']
					.concat(
						(() => {
							switch (this.data.type) {
								case 'text':
									return ['title']
								case 'image':
								case 'video':
									return ['media']
								case 'card':
									return ['title', 'media']
								default:
									return []
							}
						})()
					)
					.concat(
						(() => {
							switch (this.data.redirect_type) {
								case 'custom_link':
									return ['redirect_link']
								default:
									return []
							}
						})()
					)
			},

			pushButton(btns) {
				btns.push({
					item_label_key: '',
					item_value_key: '',
				})
			},

			removeButton(pos, btns) {
				btns.splice(pos, 1)
			},

			getKey() {
				if (this.item.hasOwnProperty('api_key')) {
					return this.item.api_key
				}
				return null
			},

			getTemplateRequestData(objInjected = {}) {
				var data = {
					channel_id: this.channel_id,
					stream_status: this.stream_status,
					data: function() {
						var result = {}
						result.type = this.data.type
						result.redirect_type = this.data.redirect_type
						if (this.data.title.length) {
							result.title = this.data.title
						}
						if (this.data.subtitle.length) {
							result.subtitle = this.data.subtitle
						}
						if (result.redirect_type != 'web_wedgit') {
							result.redirect_link = this.data.redirect_link
						}
						switch (result.type) {
							case 'card':
							case 'video':
							case 'image':
								result.media = this.data.media
								result.buttons = this.data.buttons.filter(function(btn) {
									return btn.item_label_key.length && btn.item_value_key.length
								})
								break
						}
						return result
					}.apply(this),
				}

				const values = this.prepareVariables()
				if (Object.keys(values).length) {
					data.values = values
				}

				const platform = this.platform
				if (!window.is_null(platform)) {
					data.platform = platform
				}
				return {
					...data,
					...objInjected,
				}
			},

			send() {
				var fields = this.getValidatorFields()
				this.$validator
					.validateAll(fields)
					.then((success) => {
						if (success) {
							this.$root.loader = this.stream_status ? false : true
							axios
								.post('/subscription/send_to_subscribers', this.getTemplateRequestData())
								.then((response) => {
									this.$root.loader = false
									if (response.data.status) {
										this.notifications_pending += parseInt(response.data.count)
									}
								})
								.catch(() => {
									this.$root.loader = !1
								})
						}
					})
					.catch((e) => {
						console.log(e)
					})
			},

			prepareVariables() {
				return Object.keys(this.var_vals).reduce((a, b) => {
					if (this.var_vals[b]) {
						return {
							...a,
							[b]: this.var_vals[b],
						}
					}
					return a
				}, {})
			},

			getCountSubscribers() {
				this.$root.loader = true
				var data = {
					vars: this.prepareVariables(),
					platform: this.platform,
					channel_id: this.channel_id,
				}
				axios
					.post('/subscription/count_subscribers', data)
					.then((response) => {
						if (response.data.status) {
							this.sub_count = response.data.count
							this.per_circle = response.data.per_circle
						}
						this.$root.loader = false
					})
					.catch(() => {
						this.$root.loader = false
					})
			},
		},

		created() {
			this.initComponent(parseInt(this.$route.params.id || 0), parseInt(this.$route.params.command_id || 0))
		},

		beforeDestroy() {
			this.stream_source && this.stream_source.close()
		},
	}
</script>
